import React from 'react';
import { cn } from '../../lib/utils';
import { COLLAPSED_RAIL_WIDTH_PX } from '../../lib/layoutConstants';

export { FlyoutRailBackdrop, FlyoutRailPanel } from './FlyoutFromRail';
export { RailIconButton } from './RailIconButton';

export interface CollapsedRailShellProps {
  children: React.ReactNode;
  className?: string;
  shellRef?: React.Ref<HTMLElement>;
  'aria-label'?: string;
  'aria-expanded'?: boolean;
}

/** Fixed-width collapsed rail container with overflow clipping. */
export function CollapsedRailShell({
  children,
  className,
  shellRef,
  'aria-label': ariaLabel,
  'aria-expanded': ariaExpanded,
}: CollapsedRailShellProps) {
  return (
    <aside
      ref={shellRef}
      className={cn(
        'flex h-full w-full max-w-full min-w-0 flex-shrink-0 flex-col overflow-x-hidden overflow-y-hidden border-r border-white/[0.08]',
        'bg-gradient-to-b from-[#12161d] via-[#0f1319] to-[#0c1016]',
        className,
      )}
      style={{ width: COLLAPSED_RAIL_WIDTH_PX, maxWidth: COLLAPSED_RAIL_WIDTH_PX }}
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
    >
      {children}
    </aside>
  );
}

export function CollapsedRailHeader({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'flex flex-shrink-0 items-center justify-center overflow-hidden border-b border-white/[0.08] px-2 py-2.5',
        className,
      )}
    >
      {children}
    </div>
  );
}

export function CollapsedRailBody({ children, className }: { children: React.ReactNode; className?: string }) {
  return (
    <div
      className={cn(
        'rail-nav-scroll flex min-h-0 min-w-0 flex-1 flex-col items-center gap-1 overflow-hidden px-2 py-2',
        className,
      )}
    >
      {children}
    </div>
  );
}
